/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NetworkSecurityPolicyModule
 * @preferred
 */

import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import {
    NetworkSecurityMatchTargetConfigItem,
    NetworkSecurityPolicyCollection,
    NetworkSecurityPolicyItem,
    NetworkSecurityRuleConfigItem,
} from '.';

import {
    NETWORK_SECURITY_MATCH_TARGET_CONFIG_ITEM_TOKEN,
    NETWORK_SECURITY_POLICY_COLLECTION_TOKEN,
    NETWORK_SECURITY_POLICY_ITEM_TOKEN,
    NETWORK_SECURITY_RULE_CONFIG_ITEM_TOKEN,
} from './network-security-policy.tokens';

const networkSecurityPolicyModule = angular.module('avi/network-security-policy');

const factories = [
    {
        factory: NetworkSecurityPolicyItem,
        name: NETWORK_SECURITY_POLICY_ITEM_TOKEN,
    },
    {
        factory: NetworkSecurityPolicyCollection,
        name: NETWORK_SECURITY_POLICY_COLLECTION_TOKEN,
    },
    {
        factory: NetworkSecurityRuleConfigItem,
        name: NETWORK_SECURITY_RULE_CONFIG_ITEM_TOKEN,
    },
    {
        factory: NetworkSecurityMatchTargetConfigItem,
        name: NETWORK_SECURITY_MATCH_TARGET_CONFIG_ITEM_TOKEN,
    },
];

factories.forEach(({ name, factory }) => {
    initAjsDependency(
        networkSecurityPolicyModule,
        'factory',
        name,
        factory,
    );
});
